module.exports = {"classes":["jp-whyauth0-page","header-dark"],"title":"Why Auth0","metas":{"description":"Identity in Modern Cloud-Hybrid Apps and APIs is Radically More Complex. Traditional Identity Infrastructure Is Obsolete"},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/why-auth0/metadata.json
// module id = 1626
// module chunks = 0